package ch.wsl.typings.jspreadsheetCe

import ch.wsl.typings.jspreadsheetCe.mod.CellValue
import ch.wsl.typings.std.Record
import org.scalablytyped.runtime.StObject
import scala.scalajs.js
import scala.scalajs.js.`|`
import scala.scalajs.js.annotation.{JSGlobalScope, JSGlobal, JSImport, JSName, JSBracketAccess}

object anon {
  
  @js.native
  trait Col extends StObject {
    
    var col: Double = js.native
    
    var newValue: js.UndefOr[CellValue] = js.native
    
    var oldValue: js.UndefOr[CellValue] = js.native
    
    var row: Double = js.native
    
    var x: Double = js.native
    
    var y: Double = js.native
  }
  object Col {
    
    @scala.inline
    def apply(col: Double, row: Double, x: Double, y: Double): Col = {
      val __obj = js.Dynamic.literal(col = col.asInstanceOf[js.Any], row = row.asInstanceOf[js.Any], x = x.asInstanceOf[js.Any], y = y.asInstanceOf[js.Any])
      __obj.asInstanceOf[Col]
    }
    
    @scala.inline
    implicit class MutableBuilder[Self <: Col] (val x: Self) extends AnyVal {
      
      @scala.inline
      def setCol(value: Double): Self = StObject.set(x, "col", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setNewValue(value: CellValue): Self = StObject.set(x, "newValue", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setNewValueUndefined: Self = StObject.set(x, "newValue", js.undefined)
      
      @scala.inline
      def setOldValue(value: CellValue): Self = StObject.set(x, "oldValue", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setOldValueUndefined: Self = StObject.set(x, "oldValue", js.undefined)
      
      @scala.inline
      def setRow(value: Double): Self = StObject.set(x, "row", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setX(value: Double): Self = StObject.set(x, "x", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setY(value: Double): Self = StObject.set(x, "y", value.asInstanceOf[js.Any])
    }
  }
  
  @js.native
  trait Data extends StObject {
    
    var data: Record[Double, CellValue] = js.native
    
    var row: Double = js.native
  }
  object Data {
    
    @scala.inline
    def apply(data: Record[Double, CellValue], row: Double): Data = {
      val __obj = js.Dynamic.literal(data = data.asInstanceOf[js.Any], row = row.asInstanceOf[js.Any])
      __obj.asInstanceOf[Data]
    }
    
    @scala.inline
    implicit class MutableBuilder[Self <: Data] (val x: Self) extends AnyVal {
      
      @scala.inline
      def setData(value: Record[Double, CellValue]): Self = StObject.set(x, "data", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setRow(value: Double): Self = StObject.set(x, "row", value.asInstanceOf[js.Any])
    }
  }
  
  @js.native
  trait Group extends StObject {
    
    var group: js.UndefOr[String | Double] = js.native
    
    var id: String | Double = js.native
    
    var image: js.UndefOr[String] = js.native
    
    var name: String | Double = js.native
    
    var title: js.UndefOr[String | Double] = js.native
  }
  object Group {
    
    @scala.inline
    def apply(id: String | Double, name: String | Double): Group = {
      val __obj = js.Dynamic.literal(id = id.asInstanceOf[js.Any], name = name.asInstanceOf[js.Any])
      __obj.asInstanceOf[Group]
    }
    
    @scala.inline
    implicit class MutableBuilder[Self <: Group] (val x: Self) extends AnyVal {
      
      @scala.inline
      def setGroup(value: String | Double): Self = StObject.set(x, "group", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setGroupUndefined: Self = StObject.set(x, "group", js.undefined)
      
      @scala.inline
      def setId(value: String | Double): Self = StObject.set(x, "id", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setImage(value: String): Self = StObject.set(x, "image", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setImageUndefined: Self = StObject.set(x, "image", js.undefined)
      
      @scala.inline
      def setName(value: String | Double): Self = StObject.set(x, "name", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setTitle(value: String | Double): Self = StObject.set(x, "title", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setTitleUndefined: Self = StObject.set(x, "title", js.undefined)
    }
  }
  
  @js.native
  trait Host extends StObject {
    
    var host: String = js.native
    
    var license: String = js.native
    
    def print(): String = js.native
    
    var title: String = js.native
    
    var `type`: String = js.native
    
    var version: String = js.native
  }
  object Host {
    
    @scala.inline
    def apply(host: String, license: String, print: () => String, title: String, `type`: String, version: String): Host = {
      val __obj = js.Dynamic.literal(host = host.asInstanceOf[js.Any], license = license.asInstanceOf[js.Any], print = js.Any.fromFunction0(print), title = title.asInstanceOf[js.Any], version = version.asInstanceOf[js.Any])
      __obj.updateDynamic("type")(`type`.asInstanceOf[js.Any])
      __obj.asInstanceOf[Host]
    }
    
    @scala.inline
    implicit class MutableBuilder[Self <: Host] (val x: Self) extends AnyVal {
      
      @scala.inline
      def setHost(value: String): Self = StObject.set(x, "host", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setLicense(value: String): Self = StObject.set(x, "license", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setPrint(value: () => String): Self = StObject.set(x, "print", js.Any.fromFunction0(value))
      
      @scala.inline
      def setTitle(value: String): Self = StObject.set(x, "title", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setType(value: String): Self = StObject.set(x, "type", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setVersion(value: String): Self = StObject.set(x, "version", value.asInstanceOf[js.Any])
    }
  }
  
  @js.native
  trait NewValue extends StObject {
    
    var newValue: js.UndefOr[CellValue] = js.native
    
    var value: js.UndefOr[CellValue] = js.native
    
    var x: Double = js.native
    
    var y: Double = js.native
  }
  object NewValue {
    
    @scala.inline
    def apply(x: Double, y: Double): NewValue = {
      val __obj = js.Dynamic.literal(x = x.asInstanceOf[js.Any], y = y.asInstanceOf[js.Any])
      __obj.asInstanceOf[NewValue]
    }
    
    @scala.inline
    implicit class MutableBuilder[Self <: NewValue] (val x: Self) extends AnyVal {
      
      @scala.inline
      def setNewValue(value: CellValue): Self = StObject.set(x, "newValue", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setNewValueUndefined: Self = StObject.set(x, "newValue", js.undefined)
      
      @scala.inline
      def setValue(value: CellValue): Self = StObject.set(x, "value", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setValueUndefined: Self = StObject.set(x, "value", js.undefined)
      
      @scala.inline
      def setX(value: Double): Self = StObject.set(x, "x", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setY(value: Double): Self = StObject.set(x, "y", value.asInstanceOf[js.Any])
    }
  }
}
